// @ts-nocheck

const handleStringSort = (a: string, b: string) => {
  const aValueLC = a.toLowerCase();
  const bValueLC = b.toLowerCase();

  if (aValueLC < bValueLC) {
    return -1;
  }

  if (aValueLC > bValueLC) {
    return 1;
  }

  return 0;
};

const handleNumberSort = (a: number, b: number) => {
  return a - b;
};

export const sortRows = (data: Array<Record<string, any>>, activeHeader: string | null | undefined) => {
  if (!activeHeader) {
    return data;
  }

  return data.sort((a, b) => {
    const aValue = a[activeHeader];
    const bValue = b[activeHeader];

    if (typeof aValue !== typeof bValue) {
      return 0;
    }

    switch (typeof aValue) {
      case 'string': {
        return handleStringSort(aValue, bValue);
      }

      case 'number': {
        return handleNumberSort(aValue, bValue);
      }

      // TODO JRNYS-XX handle sorting on other data types and move
      default:
        return 0;
    }
  });
};
